/**
 * Runtime configuration that gets injected into the HTML at request time.
 * This allows environment variables to be read at runtime instead of build time.
 *
 * Server-side: reads from process.env
 * Client-side: reads from window.__RUNTIME_CONFIG__ (injected by _document.tsx)
 */

export type RuntimeConfigType = {
    serverRuntimeConfig: ServerRuntimeConfigType
    publicRuntimeConfig: PublicRuntimeConfigType
}

export type ServerRuntimeConfigType = {
    apiSecretKey: string
    launchDarklySdkKey?: string
}

export type PublicRuntimeConfigType = {
    environment: string
    apiBaseUrl: string
    appUrl: string
    manageNewUrl: string
    mibBaseUrl: string
    googleApiKey: string
    googleAnalyticsTrackingId: string
    datadogClientToken: string
    bugSnagClientToken: string
    fishjamId: string
}

declare global {
    interface Window {
        __RUNTIME_CONFIG__: PublicRuntimeConfigType
    }
}

/**
 * Get runtime config from environment variables (server-side only).
 * This is used in _document.tsx to inject the config into the HTML.
 * publicRuntimeConfig's are available to access in downloaded server-side generated HTML code.
 */
export const getServerRuntimeConfig = (): RuntimeConfigType => ({
    serverRuntimeConfig: {
        apiSecretKey: process.env.API_SECRET_KEY || "",
        launchDarklySdkKey: process.env.LAUNCH_DARKLY_SDK_KEY || "",
    },
    publicRuntimeConfig: {
        environment: process.env.NEXT_PUBLIC_ENVIRONMENT || "development",
        apiBaseUrl: process.env.NEXT_PUBLIC_API_BASE_URL || "",
        appUrl: process.env.NEXT_PUBLIC_APP_URL || "",
        manageNewUrl: process.env.NEXT_PUBLIC_MANAGE_NEW_URL || "",
        mibBaseUrl: process.env.NEXT_PUBLIC_MIB_BASE_URL || "",
        googleApiKey: process.env.NEXT_PUBLIC_GOOGLE_API_KEY || "",
        googleAnalyticsTrackingId: process.env.NEXT_PUBLIC_GA_TRACKING_ID || "",
        datadogClientToken: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN || "",
        bugSnagClientToken: process.env.NEXT_PUBLIC_BUGSNAG_CLIENT_TOKEN || "",
        fishjamId: process.env.NEXT_PUBLIC_FISHJAM_ID || "",
    },
})
